import { render, staticRenderFns } from "./FalseAlertActionCard.vue?vue&type=template&id=b4349252&scoped=true&"
import script from "./FalseAlertActionCard.vue?vue&type=script&lang=js&"
export * from "./FalseAlertActionCard.vue?vue&type=script&lang=js&"
import style0 from "./FalseAlertActionCard.vue?vue&type=style&index=0&id=b4349252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4349252",
  null
  
)

export default component.exports